export function isExternalSite() {
  return location.origin.endsWith("t.edu28.ru");
}
